__turbopack_context__.v({
  "className": "plexmono_845a16af-module__rfAvYW__className",
  "variable": "plexmono_845a16af-module__rfAvYW__variable",
});
